class DownloadUrlsService {
  static factory(silentDownloadUrl, $http) {
    'ngInject';

    this.downloadURL = 'https://s3.amazonaws.com/sfproc-downloads';
    this.downloadLinks = {};
    // Get windows download URL
    const promise1 = $http({
      url: `${this.downloadURL}/released-win-v3.json`,
      method: 'GET',
    }).then(res => {
      this.windowsAppVersion3 = res.data['cloud-download-page'] || res.data.cloud;
      this.downloadLinks.windows = {
        silentUrl: silentDownloadUrl,
        interactiveUrl: `${this.downloadURL}/${this.windowsAppVersion3}/windows/bitrock/timedoctor2-setup-${this.windowsAppVersion3}-windows.exe`,
        description: 'Compatible with Windows (XP or newer)',
        descriptionSilent: 'Compatible with Windows (XP or newer)',
      };
      this.downloadLinks.other = {
        silentUrl: silentDownloadUrl,
        interactiveUrl: `${this.downloadURL}/${this.windowsAppVersion3}/windows/bitrock/timedoctor2-setup-${this.windowsAppVersion3}-windows.exe`,
        description: 'Compatible with Windows (XP or newer)',
        descriptionSilent: 'Compatible with Windows (XP or newer)',
      };
      return true;
    });

    // Get mac download URL
    const promise2 = $http({
      url: `${this.downloadURL}/released-mac-v3.json`,
      method: 'GET',
    }).then(res => {
      this.macAppVersion3 = res.data['cloud-download-page'] || res.data.cloud;
      this.downloadLinks.mac = {
        silentUrl: silentDownloadUrl,
        interactiveUrl: `${this.downloadURL}/${this.macAppVersion3}/macos/dmg/timedoctor2-${this.macAppVersion3}-macos.dmg`,
        description: 'Compatible with Mac OS (10.7, 10.8, 10.9 and 10.10)',
        descriptionSilent: 'Compatible with Windows (XP or newer)',
      };
      return true;
    });

    // Get linux download URL
    const promise3 = $http({
      url: `${this.downloadURL}/released-linux-v3.json`,
      method: 'GET',
    }).then(res => {
      this.linuxAppVersion3 = res.data['cloud-download-page'] || res.data.cloud;
      this.downloadLinks.linux = {
        silentUrl: silentDownloadUrl,
        interactiveUrl: `${this.downloadURL}/${this.linuxAppVersion3}/linux/ubuntu-18.04/interactive/timedoctor2-setup-${this.linuxAppVersion3}-linux-x86_64.run`,
        description: 'Compatible with Ubuntu (12 or newer)',
        descriptionSilent: 'Compatible with Windows (XP or newer)',
      };
      return true;
    });

    return Promise.all([promise1, promise2, promise3]).then(() => this.downloadLinks);
  }
}

export default DownloadUrlsService;
